/*eslint-disable*/ export const messages = { New: "New", "Remove {label}": ["Remove ", ["label"]] };
